// extracted by mini-css-extract-plugin
module.exports = {"botao":"BotaoTabela_botao__1Jggu","ativo":"BotaoTabela_ativo__15B19","tooltip":"BotaoTabela_tooltip__Tn5BJ"};